import { useEffect } from 'react'

// A hidden tab skips its ticks, and coming back to the window refreshes at once.
export const useRefreshWhileVisible = (refresh: () => void, intervalMs: number) => {
  useEffect(() => {
    const tick = () => {
      if (document.visibilityState === 'visible') {
        refresh()
      }
    }
    const interval = window.setInterval(tick, intervalMs)
    window.addEventListener('focus', tick)

    return () => {
      window.clearInterval(interval)
      window.removeEventListener('focus', tick)
    }
  }, [refresh, intervalMs])
}
